import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuthContext } from "../../context/authContext";
import { LoadingLayout } from "../Layouts/LoadingLayout";

export const AuthenticatedRoute = ({ children }) => {
  const { state: authState } = useAuthContext();
  const location = useLocation();


  if (!authState.appLoaded) {
    return <LoadingLayout />;
  }

  return authState.isAuthenticated ? children : <Navigate to="/login" state={{ path: location.pathname }}/>;
};
